import { c as n } from "../internals/collection.js";
import { c as t } from "../internals/collection-strong.js";
n("Set", function (n) {
  return function () {
    return n(this, arguments.length ? arguments[0] : void 0);
  };
}, t);